import Link from 'next/link';
import { ICategoryDescriptionWithImage } from '@features/pages/typescript';
import styles from '@features/pages/components/PagesAccordion/components/DescriptionWithImageAccordion.styles';
import sanitizeHtml from '@utils/sanitizeHtml';
import Button from '@components/Button/Button';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
import GetImageAlt from '@utils/getImageAlt';
import prepareURLByCMSLink from '@utils/prepareURLByCMSLink';
import { SANITIZE_HTML_CONFIG } from '@const/index';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  descriptionWithImageAccordion: ICategoryDescriptionWithImage;
};
const DescriptionWithImageAccordion = ({
  descriptionWithImageAccordion
}: PropsType) => {
  const {
    code,
    marginTop,
    marginBottom,
    background,
    title,
    description,
    textColor,
    button,
    image
  } = descriptionWithImageAccordion;
  return <div sx={styles.container(background, marginTop, marginBottom)} data-testid="DescriptionWithImageAccordion">
      <div sx={styles.image} data-testid="DescriptionWithImageAccordion-image">
        {image?.desktop && <ResponsiveImage image={image} alt={GetImageAlt(image) || title} />}
      </div>
      <div sx={styles.textContainer} data-testid="DescriptionWithImageAccordion-textContainer">
        {title && <Heading h={4} mobile pb={24} color={textColor}>
            <span dangerouslySetInnerHTML={sanitizeHtml(title)} />
          </Heading>}
        {description && <div sx={styles.descriptionText(textColor ?? theme.rawColors.darkGrey700)} dangerouslySetInnerHTML={sanitizeHtml(description, SANITIZE_HTML_CONFIG)} data-testid="DescriptionWithImageAccordion-description" />}
        {button && button?.path && <Link href={prepareURLByCMSLink(button)} data-testid="DescriptionWithImageAccordion-button">
            <Button variantColor="dark" size="small" letterCase="lowercase" cy={`${code}-button`}>
              {button.text}
            </Button>
          </Link>}
      </div>
    </div>;
};
export default DescriptionWithImageAccordion;